export default {
  created() {
    document.addEventListener("DOMContentLoaded", this.handleScroll);
  },

  methods: {
    hasPermission(
      permission,
      permissions = JSON.parse(localStorage.getItem("user-permissions"))
    ) {
      return permission.some(val => permissions.includes(val));
      /*permission must be an array*/
    },
    handleScroll(event) {
      this.anime = this.$anime({
        targets: ".card",
        scale: [0, 1],
        opacity: [0, 1],
        easing: "easeInOutSine",
        duration: 2000
      });

      // this.$anime
      //   .timeline({
      //     easing: "easeOutExpo"
      //   })
      //   .add(
      //     {
      //       targets: ".navbar-default",
      //       translateX: [-1500, 0],
      //       duration: 2000, delay: 1000
      //     },
      //   );
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
